import PropTypes from 'prop-types';

/**
 * Metadata pertaining to a Contact under review.
 */
const ReviewContextType = PropTypes.shape({
  /** Subset of Contact data pertaining to review. */
  contact: PropTypes.object,

  /** Reviewable documents. */
  documents: PropTypes.arrayOf(PropTypes.object),

  /** Key information and demographic field metadata. */
  fields: PropTypes.arrayOf(PropTypes.object),

  /** Pagination information related to the Reader page flow. */
  paginator: PropTypes.shape({
    currPage: PropTypes.object,
    nextPage: PropTypes.object,
    prevPage: PropTypes.object,
    pages: PropTypes.arrayOf(PropTypes.object),
  }),

  /** Indicates if review context is populated. */
  ready: PropTypes.bool,

  /** Summary info about reviews assigned to a contact. */
  reviews: PropTypes.arrayOf(PropTypes.object),
});

export default ReviewContextType;
